import axios from "axios";
import { useAuthStore } from "../../stores/stores";
import { message } from "antd";

export const BASE_URL_DEFAULT = `${process.env.REACT_APP_BASE_API_URL}`;

export const axiosConfigToUploadBase = axios.create({
  baseURL: BASE_URL_DEFAULT,
  timeout: 600000,
  withCredentials: true,
  headers: {
    "content-type": "multipart/form-data",
  },
});

axiosConfigToUploadBase.interceptors.request.use(
  (config) => {
    const accessToken = useAuthStore.getState().accessToken;
    if (!config.headers["Authorization"] || accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosConfigToUploadBase.interceptors.response.use(
  (response) => response,
  async (error) => {
    const prevRequest = error?.config;

    if (!error.response) {
      console.error("Network or CORS error:", error.message);

      message.error("Lỗi mạng hoặc CORS: Không thể kết nối tới máy chủ.");
      return Promise.reject(error);
    }

    if (error?.response?.status === 403 && !prevRequest?.sent) {
      prevRequest.sent = true;
      try {
        const refreshToken = useAuthStore.getState().refreshToken;
        const accessToken = useAuthStore.getState().accessToken;
        if (refreshToken && accessToken) {
          prevRequest.headers["Authorization"] = `Bearer ${accessToken}`;
          return axiosConfigToUploadBase(prevRequest);
        }
      } catch (error) {
        location.replace("/login");
      }
    } else if (
      error?.response?.status === 401 ||
      error?.response?.status === 503
    ) {
      const logout = useAuthStore.getState().logout;
      logout();
    } else {
      message.error(error);
    }
    return Promise.reject(error);
  }
);
